import { MessageService } from 'primeng/api';
import { isEmpty } from './functions';

export function successMsg(service: MessageService, message: string | null, extendedLife: boolean = false) {
  const msg: string = isEmpty(message) ? `Action succeeded` : <string>message;
  service.add({ severity: 'success', summary: 'Success', detail: msg, life: extendedLife ? 5000 : 3000 });
}

export function warningMsg(service: MessageService, message: string | null, extendedLife: boolean = false) {
  const msg: string = isEmpty(message) ? `Warning` : <string>message;
  service.add({ severity: 'warn', summary: 'Warning', detail: msg, life: extendedLife ? 5000 : 3000 });
}

export function errorMsg(service: MessageService, error: any, extendedLife: boolean = false) {
  const msg = error?.error?.userMessage ?? error.statusText ?? error;
  service.add({ severity: 'error', summary: 'Error', detail: msg, life: extendedLife ? 5000 : 3000 });
}
